<script lang="ts">
    import { tick, untrack } from 'svelte';

    interface Props {
        isIOSApp: boolean;
        cacheRestored: boolean;
        restoreScrollPosition: () => Promise<void>;
        saveScrollSelector: () => void;
    }

    const { isIOSApp, cacheRestored, restoreScrollPosition, saveScrollSelector }: Props = $props();

    /**
 *
 *
 */
    $effect(() => {
        window.history.scrollRestoration = 'manual';

        let scrollDebounceId: ReturnType<typeof setTimeout> | undefined;

        function handleScroll() {
            clearTimeout(scrollDebounceId);
            scrollDebounceId = setTimeout(saveScrollSelector, 150);
        }

        function handleVisibilityChange() {
            if (document.visibilityState === 'hidden') {
                clearTimeout(scrollDebounceId);
                saveScrollSelector();
            }
        }

        window.addEventListener('scroll', handleScroll, { passive: true });
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            window.history.scrollRestoration = 'auto';
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            clearTimeout(scrollDebounceId);
        };
    });

    let restorationStarted = false;

    /**
 *
 *
 *
 *
 */
    $effect(() => {
        if (!cacheRestored || restorationStarted) return;
        restorationStarted = true;

        return untrack(() => {
            let active = true;
            let timeoutId: ReturnType<typeof setTimeout> | undefined;

            function restore() {
                if (active) restoreScrollPosition();
            }

            function scheduleRestoration() {
                if (!active) return;
                if (isIOSApp) {
                    timeoutId = setTimeout(restore, 250);
                } else {
                    restoreScrollPosition();
                }
            }

            tick().then(scheduleRestoration);

            return () => {
                active = false;
                clearTimeout(timeoutId);
            };
        });
    });
</script>
